import { useState } from 'react'

import { AppPath } from '../enums/AppPath'
import { NvvAction, ReservaAction } from '../enums/DocActions'

import CheckboxField from './CheckBoxField'

const DocConfirma: React.FC<{
  docType: AppPath
  handleCrearClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  action?: number
  loading?: boolean
}> = ({ docType, handleCrearClick, action, loading }) => {
  const [check, setCheck] = useState<boolean>(false)
  let singular
  let labelIni
  let title = 'Confirmación'
  let checkLabel = ''
  let buttonLabel = 'Crear'
  const myAction = action ?? 0

  switch (docType) {
    case AppPath.Estimates:
      singular = 'cotización'

      if (myAction === 0) {
        labelIni = 'Al crear la cotización esta quedará activa y asociada al cliente y vehículo de forma permanente.'
      } else {
        labelIni = ''
        title = ''
        checkLabel = 'Estoy seguro de anular esta cotización.'
        buttonLabel = 'Anular'
      }
      break
    case AppPath.Consignments:
      singular = 'consignación'

      if (myAction === 0) {
        labelIni = 'Al crear la consignación, esta ya no podrá ser modificada.'
      } else if (myAction === 1) {
        labelIni = ''
        title = ''
        checkLabel = 'Estoy seguro de cambiar el precio cliente.'
        buttonLabel = 'Cambiar'
      } else {
        labelIni = ''
        title = ''
        checkLabel = 'Estoy seguro de archivar esta consignación.'
        buttonLabel = 'Archivar'
      }
      break
    case AppPath.Reservations:
      singular = 'reserva'

      if (myAction === ReservaAction.Crear) {
        labelIni = ''
      } else if (myAction === ReservaAction.Completar) {
        buttonLabel = 'Completar...'
        checkLabel = 'Estoy seguro de completar esta reserva.'
      } else if (myAction === ReservaAction.Modificar) {
        labelIni = ''
        title = ''

        buttonLabel = 'Grabar modificaciones'
      } else if (myAction === ReservaAction.Anular) {
        labelIni = ''
        title = ''
        checkLabel = 'Estoy seguro de anular esta reserva.'
        buttonLabel = 'Anular'
      } else {
        labelIni = 'Reserva Indefinido'
        title = 'Reserva Indefinido'

        buttonLabel = 'Reserva Indefinido'
      }
      break
    case AppPath.SaleNotes:
      singular = 'nota de venta'

      //TODO: Por que esta en modo NvvAction.SoloReserva
      // cuando se crea desde Reserva ???
      if (myAction == NvvAction.Crear || myAction === NvvAction.SoloReserva) labelIni = ''
      else if (myAction === NvvAction.Modificar) {
        labelIni = ''
        title = ''
        buttonLabel = 'Grabar modificaciones'
      } else if (myAction === NvvAction.Anular) {
        labelIni = ''
        title = ''
        checkLabel = 'Estoy seguro de anular esta nota de venta.'
        buttonLabel = 'Anular'
      } else if (myAction === NvvAction.Aprobar) {
        labelIni = ''
        title = ''
        checkLabel = 'Estoy seguro de aprobar esta nota de venta.'
        buttonLabel = 'Aprobar'
      } else {
        labelIni = 'Indefinido'
        title = 'Indefinido'
        buttonLabel = 'Indefinido'
      }

      break
    case AppPath.Settlements:
      singular = 'liquidación'

      if (myAction === 0) {
        labelIni = 'Al crear la liquidación, esta ya no podrá ser modificada.'
      } else if (myAction === 1) {
        labelIni = 'Al anular la liquidación, esta ya no será legalmente válida.'
        title = 'Anular liquidación'
        checkLabel = 'Estoy seguro de anular esta consignación.'
        buttonLabel = 'Anular'
      }
      break
    default:
      singular = 'DESCONOCIDO'
      break
  }

  if (checkLabel === '') {
    checkLabel = `Confirmo que los datos de la ${singular} son correctos.`
  }
  // Handle checkbox change
  const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target
    setCheck(checked)
  }

  const handleCrearClickInt = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!check) return
    handleCrearClick(e)
  }
  const classCommon = 'py-2 px-4 rounded mt-0 mb-2 transition-colors duration-200'
  const classChecked =
    'bg-blue-500 text-white cursor-pointer hover:bg-blue-600 disabled:bg-blue-400 disabled:cursor-wait'
  const classUnChecked = 'bg-gray-400 text-gray-200 cursor-not-allowed'
  const buttonClassName = `${classCommon} ${check && !loading ? classChecked : check && loading ? 'bg-blue-400 text-white cursor-wait' : classUnChecked}`

  return (
    <>
      <div className="mb-2 mt-4">
        <span className="font-bold">{title}</span>
      </div>
      <div>{labelIni}</div>
      <div className="border border-gray-300 p-4 rounded-md shadow-sm">
        <CheckboxField
          name="aceptar"
          value=""
          label={checkLabel}
          checked={check}
          handleInputChange={handleCheckChange}
        />
      </div>
      <div className="flex justify-center mt-1">
        <button
          className={buttonClassName}
          onClick={handleCrearClickInt}
          disabled={!check || loading} // Disable the button when not checked or loading
        >
          {loading ? 'Procesando...' : buttonLabel}
        </button>
      </div>
    </>
  )
}

export default DocConfirma
